.inputs.plan{width:100%;margin-left:0}.plan-submitted .plan.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=care-team-add.component-JK4ZKXV3.css.map */
